import React from 'react';
import DOMPurify from 'dompurify';
import { MFBeaconModal } from '../Beacon/BeaconComponents';

const PaperlessTermsModal = ({ termsAEMContent }) => {
  return (
    <MFBeaconModal id="electronicAccessModal" scale="normal">
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(termsAEMContent)
        }}
      />
    </MFBeaconModal>
  );
};

export default PaperlessTermsModal;
